
window.addEventListener('DOMContentLoaded', function() {
  /* --------------- fade in anime --------------- */	
  const fadeinElements = document.querySelectorAll('.fade-in');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  fadeinElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
			setTimeout(function() {
      	element.classList.add('scrollin');
			}, 500);
    }
  });
  const scrollElements = document.querySelectorAll('.scroll_anime');

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});

window.addEventListener('scroll', function() {
  /* --------------- fade in anime --------------- */	
  const scrollElements = document.querySelectorAll('.scroll_anime');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  scrollElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
      element.classList.add('scrollin');
    }
  });
});


/* --------------- youtube-thumbnail --------------- */
document.addEventListener('DOMContentLoaded', function () {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


	function videoControl(action) {
		const playerWindow = $("#youtube_player")[0].contentWindow;
		playerWindow.postMessage(
			'{"event":"command","func":"' + action + '","args":""}',
			"*"
		);
	}

	document.querySelectorAll('.mv__cover').forEach(function(thumbnail) {
		thumbnail.addEventListener('click', function() {
			// クリックされた要素をフェードアウトする
			this.style.transition = 'opacity 0.9s'; // フェードアウトのアニメーションを設定
			this.style.opacity = 0; // 透明にする
			this.style.zIndex = 0; // 透明にする

			// videoControl関数を呼び出し
			videoControl('playVideo');
		});
	});
});
